import useSWR from "swr";

import { type WorkflowTemplateListItem } from "../types";
import { simpleFetcher } from "../fetcher";

const url = "/api/v2/workflow-templates";

export function useWorkflowTemplates() {
  return useSWR<WorkflowTemplateListItem[], Error>(url, simpleFetcher);
}
